import { Component, Input, EventEmitter, Output, OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedRequestParameters, EntityOrderedRequestParameters, BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { Observable } from 'rxjs';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { HistoricoLimiteAgenteFinanceiro, HistoricoLimiteFundoCadastro } from 'src/app/model/limite-agente-financeiro.model';
import { DadosClienteDTO } from 'src/app/model/questionario.model';
import { LimiteService } from 'src/app/shared/services/limite.service';



@Component({
    selector: 'app-limite-historico-listagem',
    templateUrl: './limite-historico-listagem.component.html',
    styleUrls: ['./limite-historico-listagem.component.scss'],
    standalone: false
})
export class LimiteHistoricoListagemComponent extends BaseEntityComponent<any> implements OnInit {

  @Input() public historico: HistoricoLimiteFundoCadastro[] = [];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public apenasAlteracoesManuais: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(protected injector: Injector,
    protected service: LimiteService,
    private modalService: BnModalMessageService,
    private loadingService: BnLoadingService,
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }

  }

  changeCheck(evento) {
    this.apenasAlteracoesManuais.emit(evento.target.checked)
  }
  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.historico = this.historico.sort((a, b) => {
      if (ord.sentido === 'asc') {
        return this.compara(a, b, ord.atributo);
      } else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
      return 0;
    } else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      } else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    const _index = prop.indexOf('.');
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  voltar() {
    this.router.navigate(["/limite/pesquisa"]);
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }



}
